import { Link, Text } from '@change/ds-core-ui';
import { ArrowRightIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';

import { usePetitionActivityLink } from './hooks/usePetitionActivityLink';
import type { LinkType } from './types';

type Props = {
	slug: string;
	linkType?: LinkType;
};

// Renders a link to the petition activity page with a trailing icon and a text label.
// In the future, this component will also display a badge counter for the number of new activity items.
export function PetitionActivityLink({ slug, linkType }: Props) {
	const {
		data: { href, linkTextTranslationKey },
	} = usePetitionActivityLink({ slug, linkType });

	return (
		<Link
			href={href}
			data-testid="petition-activity-link"
			variant="secondary"
			trailingIcon={<ArrowRightIcon size="small" />}
			data-qa="petition-activity-link"
		>
			<Text className="text-size-body-bold sm:hidden md:inline">
				<Translate value={`corgi.petition_activity.shared.${linkTextTranslationKey}`} />
			</Text>
			<div className="flex flex-row items-center gap-[3px] md:hidden">
				<Text className="text-size-body-bold">All</Text>
			</div>
		</Link>
	);
}
